<template>
    <div v-can="'settings_status_mapper.access'" class="mapping_statuses" v-if="isMounted">
        <ds-table :data="statuses" :heads="heads" search spacer :view-items="[10, 15, 20]" :max-items="10">
            <template v-slot:header>
                <vs-button v-can="'settings_status_mapper.create'" @click="create" class="mr-4 whitespace-no-wrap" color="primary" type="border" v-bind="$iconData('icon-plus', 'fi-rr-plus')">{{$t('buttons.Create_status')}}</vs-button>
                <vs-button v-can:show="'settings_status_mapper.create'" disabled class="mr-4 whitespace-no-wrap" color="primary" type="border" v-bind="$iconData('icon-plus', 'fi-rr-plus')">{{$t('buttons.Create_status')}}</vs-button>
            </template>

            <template v-slot:action="{action}">
                <vs-button v-can="'settings_status_mapper.update'" radius color="primary" type="flat" v-bind="$iconData('icon-edit-2', 'fi-rr-file-edit')" @click="update(action)" v-tooltip="$t('modals.Edit_Status')"></vs-button>
                <vs-button v-can:show="'settings_status_mapper.update'" disabled radius color="primary" type="flat" v-bind="$iconData('icon-edit-2', 'fi-rr-file-edit')" v-tooltip="$t('modals.Edit_Status')"></vs-button>
            </template>
        </ds-table>
    </div>
</template>

<script>
import ErrorHandler from "@/utils/errorHandler"
import send from "@/utils/fetch"
import EventBus from "@/store/eventBus"

export default {
    data() {
        return {
            isMounted: false,
            statuses: [],
            heads: [
                { name: 'global.Internal_status', key: 'internal_status', sortKey: 'internal_status', value: 'internal_status', display: true},
                { name: 'global.External_status', key: 'external_status', sortKey: 'external_status', value: 'external_status', display: true},
                { name: 'global.Actions', key: 'actions', value: 'action', display: true}
            ]
        }
    },

    methods: {
        create() {
            EventBus.$emit('emitPopupEvent', {type: 'createStatus', name: this.$t('buttons.Create_status')})
        },

        update(data) {
            EventBus.$emit('emitPopupEvent', {type: 'editStatus', name: this.$t('modals.Edit_Status'), data})
        },

        async get() {
            try {
                this.statuses = await send(this.$url["status-mapping"].get, 'GET').then(response => response.data.result)
                this.isMounted = true
            } catch (e) {
                this.isMounted = false
                new ErrorHandler(e).send
            }
        }
    },

    async mounted() {
        await this.get()

        EventBus.$on('updateStatus', async () => {
            await this.get()
        })
    },

    beforeDestroy() {
        EventBus.$off('updateStatus')
    }
}
</script>
